import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import {
  TuiButtonModule,
  TuiSvgModule,
  TuiTextfieldControllerModule,
} from '@taiga-ui/core';
import { SwUpdate } from '@angular/service-worker';
import {
  BroadcastChannelService,
  MessageTypes,
} from '@shared/services/broadcast-channel.service';
import { TuiIconModule } from '@taiga-ui/experimental';
import { WINDOW } from '@shared/providers/window.provider';

@Component({
  selector: 'app-version-available',
  standalone: true,
  imports: [
    TuiSvgModule,
    TuiTextfieldControllerModule,
    TuiButtonModule,
    TuiIconModule,
  ],
  templateUrl: './version-available.component.html',
  styleUrl: './version-available.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VersionAvailableComponent {
  constructor(
    private readonly swUpdate: SwUpdate,
    private readonly broadcast: BroadcastChannelService,
    @Inject(WINDOW) private readonly window: Window,
  ) {}

  protected async applyUpdateAndReloadAll() {
    try {
      await this.swUpdate.activateUpdate();

      this.broadcast.postMessage({ type: MessageTypes.RELOAD_TAB });

      this.window.location.reload();
    } catch (err) {
      console.error('Ошибка при активации обновления', err);
      throw err;
    }
  }
}
